import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { IInsuranceState } from './store/insurance.state';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { setInsuranceAction } from './store/insurance.actions';
import { getInsuranceSelectors } from './store/insurance.selectors';
import { IInsurance } from 'src/app/modules/interfaces/insurances.interface';
import { InsuranceService } from 'src/app/services/insurances.service';
import { getCookie } from 'src/app/utils/get-cookie';

@Component({
  selector: 'app-insurance',
  templateUrl: './insurance.component.html',
  styleUrls: ['./insurance.component.scss'],
})
export class InsuranceComponent implements OnInit {
  @Output() formSaved = new EventEmitter<void>();
  formsId: number;
  insuranceData: IInsurance = {
    id: 0,
    has_insurance: null,
    insurances_name: null,
    insurance_satisfaction: null,
    wants_insurance_study: null,
  };

  isLoading = true;
  isSaving = false;
  saveButtonText = 'Salvar';
  saveButtonClass = 'btn-primary';

  dataState$: Observable<IInsuranceState>;
  dataState: IInsuranceState;

  constructor(
    private store: Store,
    private insuranceService: InsuranceService
  ) {
    this.formsId = Number(getCookie('formsId'));
  }

  ngOnInit(): void {
    this.getState();
    this.loadInsuranceData()
  }

  loadInsuranceData(): void {
    
    this.isLoading = true;

    this.insuranceService.getInsuranceData(this.formsId).subscribe((response) => {
      if (response) {
        this.insuranceData = {
          id: response.id,
          has_insurance: response.has_insurance,
          insurances_name: response.insurances_name || '',
          insurance_satisfaction: response.insurance_satisfaction || '',
          wants_insurance_study: response.wants_insurance_study,
        };
        this.saveState()
      }
    });
  }

  saveForm(): void {
    this.isSaving = true;
    this.saveButtonText = 'Salvando...';
    this.saveButtonClass = 'btn-secondary';

    const updateData: any = {
      has_insurance: this.insuranceData.has_insurance,
    };

    if (this.insuranceData.insurances_name) {
      updateData.insurances_name = this.insuranceData.insurances_name;
    }
    if (this.insuranceData.insurance_satisfaction) {
      updateData.insurance_satisfaction = this.insuranceData.insurance_satisfaction;
    }
    if (this.insuranceData.wants_insurance_study !== null) {
      updateData.wants_insurance_study = this.insuranceData.wants_insurance_study ? 1 : 0;
    }

    this.insuranceService
      .updateInsuranceData(this.formsId, this.insuranceData.id, updateData)
      .subscribe({
        next: () => {
          this.isSaving = false;
          this.saveButtonText = 'Salvo';
          this.saveButtonClass = 'btn-primary';
          this.saveState()
          this.formSaved.emit();
        },
        error: (err) => {
          this.isSaving = false;
          this.saveButtonText = 'Erro ao salvar';
          this.saveButtonClass = 'btn-danger';
          console.error('Erro ao atualizar os dados do seguro', err);
        },
      });
  }

  saveState(): void {
    this.dataState = {
      ...this.dataState,
      check: true,
      insurance: this.insuranceData.has_insurance === 1, 
      insuranceName: this.insuranceData.insurances_name || '',
      safeWithInsurance: this.insuranceData.insurance_satisfaction || '',
      interest: this.insuranceData.wants_insurance_study === 1,
    };

    this.setState(this.dataState);
  }

  onFieldChange(): void {
    if (!this.isSaving) {
      this.saveButtonText = 'Salvar';
      this.saveButtonClass = 'btn-primary';
    }
  }

  startTrial(): void {
    this.setState(this.dataState);
  }

  setState(data: IInsuranceState) {
    this.store.dispatch(setInsuranceAction(data));
    this.isLoading = false;
  }

  getState() {
    this.dataState$ = this.store.select(getInsuranceSelectors);

    this.dataState$.subscribe((value) => {
      this.dataState = {
        ...(this.dataState = value),
      };
    });
  }

  setValuesForm(): void {
    this.dataState.check = false;
    if (this.dataState.insurance != undefined) {
      this.dataState.check = true;
    }
    this.setState(this.dataState);
  }
}
